import { CubeTimeDimensionGranularity } from '../../../common/enum/cube-time-dimension-granularity.enum';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfTopAppCategoryAppsRequestDto {
  params: {
    startDate: string;
    appCategoryId: string;
    granularity: CubeTimeDimensionGranularity;
    limit?: number;
    offset?: number;
  };
  config: CubeRequestConfig;
}
